// extracted by mini-css-extract-plugin
export default {"form__info-counter":"SymbolsCounter_form__info-counter__Cta7H","exceed":"SymbolsCounter_exceed__sQAAH"};